export interface SkinStructureLimits {
  patternCount: number;
  themeCounts: readonly number[];
}

// Extracted from the current EVRIMA DT_SkinDataList asset. PatternIndex and
// ThemeIndex are zero-based in CustomizerData.
const limitsBySpecies: Readonly<Record<string, readonly number[]>> = {
  allosaurus: [2, 2, 2],
  austroraptor: [2, 2, 2, 1],
  baryonyx: [2, 2, 2, 1, 1],
  beipiaosaurus: [2, 2, 2],
  carnotaurus: [2, 2, 2, 1],
  ceratosaurus: [2, 2, 2],
  deinosuchus: [2, 2, 2],
  diabloceratops: [2, 2, 2],
  dilophosaurus: [2, 2, 2],
  dryosaurus: [2, 2, 2],
  gallimimus: [2, 2, 2],
  herrerasaurus: [2, 2, 2, 1, 1],
  hypsilophodon: [2, 2, 2],
  kentrosaurus: [2, 2, 2],
  maiasaura: [2, 2, 2],
  omniraptor: [2, 2, 2, 1, 2, 1],
  oviraptor: [2, 2, 2],
  pachycephalosaurus: [2, 2, 2, 1, 1],
  pteranodon: [2, 2, 2],
  stegosaurus: [2, 2, 2, 1],
  tenontosaurus: [1, 1, 1],
  triceratops: [1, 1, 1, 1, 1, 1],
  troodon: [2, 2, 2],
  tyrannosaurus: [2, 2, 2, 1, 1]
};

export function skinStructureLimitsForSpecies(species: string): SkinStructureLimits | undefined {
  const themeCounts = limitsBySpecies[normalizeSkinSpecies(species)];
  return themeCounts ? { patternCount: themeCounts.length, themeCounts } : undefined;
}

export function skinThemeCountForPattern(species: string, patternIndex: number): number | undefined {
  if (!Number.isSafeInteger(patternIndex) || patternIndex < 0) return undefined;
  return skinStructureLimitsForSpecies(species)?.themeCounts[patternIndex];
}

function normalizeSkinSpecies(value: string): string {
  const leaf = value.trim().split(/[\\/]/).at(-1) ?? value;
  const normalized = leaf
    .replace(/^BP_/i, "")
    .replace(/(?:\.[^.]+)?_C$/i, "")
    .replace(/[^a-z0-9]/gi, "")
    .toLowerCase();
  return normalized === "deinonychus" || normalized === "utahraptor" ? "omniraptor" : normalized;
}
